import React from "react";
import {Price} from "../../common/ui/Price";
import {FormattedNumber} from "../../common/ui/FormattedNumber";

/**
 * @param {{
 *      recap: {
 *          price: { value: number, bestPrice: number },
 *          discount: { value: number, percentage: number, line: string }
 *      },
 *      children?: React.ReactNode
 * }} props
 */
const ProductPurchase = ({recap, children}) => {

    const PurchaseControls = React.Children.toArray(children)
        .find(child => React.isValidElement(child) && child.type === ProductPurchase.PurchaseControls)

    if (!recap) return null;

    return (
        <div
            className="py-3 py-xl-1 rounded-2 row gap-2 gap-xl-0 align-items-center justify-content-center justify-content-xl-end"
            style={{minHeight: '100px'}}
        >
            <hr className="col-12"/>

            <div className="col-12 pb-2 pb-xl-0 col-xl-5 d-flex flex-row justify-content-center gap-2 justify-content-xl-end gap-xl-0 align-items-center">
                {
                    recap.discount.value > 0 && (
                        <>
                            <div className="d-flex gap-2">
                                {
                                    recap.discount?.percentage > 0 && (
                                        <div className="d-flex flex-column align-items-center">
                                            <small className="text-muted">%&nbsp;ahorro</small>
                                            <strong className="text-primary">
                                                <strong className="fs-5">
                                                    <FormattedNumber value={recap.discount.percentage} config={{style: "percent"}} />
                                                </strong>
                                            </strong>
                                        </div>
                                    )
                                }
                                {
                                    recap.discount?.value > 0 && (
                                        <div className="d-flex flex-column align-items-center">
                                            <small className="text-muted">Ahorro</small>
                                            <strong className="text-primary">
                                                <strong className="fs-5">
                                                    <FormattedNumber value={recap.discount.value} config={{style: "currency"}} />
                                                </strong>
                                            </strong>
                                        </div>
                                    )
                                }
                            </div>

                            <div className="mx-3 d-xl-flex align-items-strech fw-bold">
                                <div className="vr my-2" style={{height: '60px', width: '2px'}}></div>
                            </div>
                        </>
                    )
                }
                {
                    recap.price?.bestPrice >= 0 && (
                        <div className="d-flex gap-2">
                            <div className="d-flex flex-column align-items-center">
                                <small>Total</small>
                                <Price
                                    data={{sellingPrice: recap.price?.bestPrice, basePrice: recap.price?.value}}
                                    config={{size: "large"}}
                                />
                            </div>
                        </div>
                    )
                }
                <div className="ms-3 d-none d-xl-flex align-items-strech fw-bold">
                    <div className="vr my-2" style={{height: '60px', width: '2px'}}></div>
                </div>
            </div>

            <div className="col-12 col-xl-5 d-flex align-items-center justify-content-center">
                {PurchaseControls}
            </div>
        </div>
    );
}
export default ProductPurchase

ProductPurchase.PurchaseControls = ({children}) => <>{children}</>;


